module.exports = __webpack_public_path__ + "img/t3.3c147824.svg";